import React from "react";
import s from "./banner.module.scss";

export type BannerProps = {
  message: string;
  type: "success" | "error" | "warning";
};

const NotificationBanner: React.FC<BannerProps> = ({ message, type }) => {
  return (
    <div className={`${s.banner} ${type === "success" ? s.success : type == "warning" ? s.warning : s.error}`}>
      {message}
    </div>
  );
};

export default NotificationBanner;